<span [innerHTML]="currentText"></span>